import Vue from 'vue'
export default {
	namespaced: true,
	state: {
		listadoToasts: [],
		id: 0
	},

	getters: {
		toasts (state) {
			return state.listadoToasts
		}
	},

	mutations: {
		// Marca el toast para eliminarse
		close (state, id) {
			for (let i = 0; i < state.listadoToasts.length; i++) {
				if (state.listadoToasts[i].id === id) {
					state.listadoToasts[i].close = true
				}
			}
		},

		/**
		 * Creamos una notificación de progreso que podremos modificar y actualizar
		 * @param {*} state
		 * @param {*} payload
		 */
		progress (state, payload) {
			if (!payload.id) {
				return
			}

			payload.type = 'progress'
			payload.timeout = null
			payload.closable = false
			payload.icon = (!payload.icon) ? 'fa fa-check' : payload.icon
			payload.style = 'bg-success text-white'

			// Buscamos si existe
			for (let i = 0; i < state.listadoToasts.length; i++) {
				if (state.listadoToasts[i].id === payload.id) {
					Vue.set(state.listadoToasts, i, payload)
					return
				}
			}
			state.listadoToasts.push(payload)
		},

		// Elimina definitivamente el toast del DOM
		delete (state, id) {
			for (let i = 0; i < state.listadoToasts.length; i++) {
				if (state.listadoToasts[i].id === id) {
					state.listadoToasts.splice(i, 1)
					return
				}
			}
		},
		success (state, payload) {
			payload.id = ++state.id
			if (!payload.timeout || typeof payload.timeout !== 'number') {
				payload.timeout = 10
			}
			payload.closable = (typeof payload.closable === 'boolean') ? payload.closable : true
			payload.icon = (!payload.icon) ? 'fa fa-check' : payload.icon
			payload.style = 'bg-success text-white'
			state.listadoToasts.push(payload)
		},
		danger (state, payload) {
			payload.id = ++state.id
			if (!payload.timeout || typeof payload.timeout !== 'number') {
				payload.timeout = 10
			}
			payload.closable = (typeof payload.closable === 'boolean') ? payload.closable : true
			payload.icon = (!payload.icon) ? 'fa fa-ban' : payload.icon
			payload.style = 'bg-danger text-white'
			state.listadoToasts.push(payload)
		},
		warning (state, payload) {
			payload.id = ++state.id
			if (!payload.timeout || typeof payload.timeout !== 'number') {
				payload.timeout = 10
			}
			payload.closable = (typeof payload.closable === 'boolean') ? payload.closable : true
			payload.style = 'bg-warning'
			payload.icon = (!payload.icon) ? 'fa fa-exclamation-triangle' : payload.icon
			state.listadoToasts.push(payload)
		},
		light (state, payload) {
			payload.id = ++state.id
			if (!payload.timeout || typeof payload.timeout !== 'number') {
				payload.timeout = 10
			}
			payload.closable = (typeof payload.closable === 'boolean') ? payload.closable : true
			payload.style = 'bg-light text-dark'
			payload.icon = (!payload.icon) ? 'fa fa-info-circle' : payload.icon
			state.listadoToasts.push(payload)
		},
		dark (state, payload) {
			payload.id = ++state.id
			if (!payload.timeout || typeof payload.timeout !== 'number') {
				payload.timeout = 10
			}
			payload.closable = (typeof payload.closable === 'boolean') ? payload.closable : true
			payload.style = 'bg-dark text-white'
			payload.icon = (!payload.icon) ? 'fa fa-info-circle' : payload.icon
			state.listadoToasts.push(payload)
		},
		info (state, payload) {
			payload.id = ++state.id
			if (!payload.timeout || typeof payload.timeout !== 'number') {
				payload.timeout = 10
			}
			payload.closable = (typeof payload.closable === 'boolean') ? payload.closable : true
			payload.icon = (!payload.icon) ? 'fa fa-info-circle' : payload.icon
			payload.style = 'bg-info text-white'
			state.listadoToasts.push(payload)
		}
	}
}



// WEBPACK FOOTER //
// ./src/modulos/core/vue/store/toast.js